import { IAPIRoutes } from "../../../../config";

export type IRespRateRepository = ReturnType<typeof RespRateRepositoryFactory>;

export const RespRateRepositoryFactory = ({
  APIProvider,
  AuthService,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  AuthService: IAuthService;
  APIRoutes: IAPIRoutes;
}) => {
  const { POST } = APIProvider;
  const { getAuthenticationToken } = AuthService;

  const getRespRateAPI: IRespRateAPI = async (payload) =>
    POST(
      APIRoutes.apiGetPatientRespRate.replace(
        "{clinic_id}",
        payload.clinic_id?.toString()
      ),
      payload,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  return {
    getRespRateAPI,
  };
};
